module.exports = __webpack_public_path__ + "static/media/captions_Linotype.584b26e4.vtt";


//////////////////
// WEBPACK FOOTER
// ./src/subtitles/captions_Linotype.vtt
// module id = 122
// module chunks = 0